<template>
  <v-card style="font-family: anjoman !important;" id="cardNews">
    <v-data-table
      :headers="headers"
      :items="desserts"
      loading-text="در حال بروز رسانی. لطفا اندکی صبر کنید"
      class="elevation-1 mytable"
      @update:options="updateTable($event)"
      :server-items-length="rowCount"

    >
      <!--    <v-progress-linear v-show="progressBar" slot="progress" color="blue" indeterminate></v-progress-linear>-->
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>اخبار و اطلاعيه</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog
            style="font-family: anjoman !important"
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#E72480"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                style="font-family: anjoman !important;"
              >
                افزودن
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span style="font-family: anjoman !important;" class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        style="font-family: anjoman !important;font-weight: normal"
                        v-model="editedItem.title"
                        label="عنوان خبر"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-file-input
                        style="font-family: anjoman!important;font-weight: normal!important;"
                        v-model="imageFile"
                        label="تصویر اصلی"
                        v-on:change="showMainImage($event)"
                        v-on:click:clear="deleteMainImage"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                            color="#E72480"
                            dark
                            label
                            small
                            style="color: white"
                          >
                           1-files
                          </v-chip>
                        </template>
                      </v-file-input>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
<!--                      <template v-slot:item.file="{item}">-->
                      <template>
                        <div style="display: flex;width: max-content">
                        <v-img width="75" lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" alt="تصویر اطلاعیه" height="50px" v-if="editedItem.file" :src="baseUrl+editedItem.file">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                          <v-icon
                            size="30"
                            small
                            @click="popFile(editedItem.file)"
                            color="red"
                            class="rounded-circle"
                            style="background-color: white"
                          >
                            mdi-delete
                          </v-icon>
                        </v-img>
                          <v-img style="max-width: 75px"  width="75"  alt="تصویر اطلاعیه" height="50px"  :src="mainImage"></v-img>
                        </div>
                      </template>
                      <v-dialog v-model="flagDialogFile" max-width="500px">
                        <v-card>
                          <v-card-title style="font-family: anjoman !important" class="headline">آيا از حذف این تصویر مطمئن می‌باشید؟</v-card-title>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn style="font-family: anjoman !important;" color="#E72480" text @click="closeDeleteFile">لغو</v-btn>
                            <v-btn style="font-family: anjoman !important;" :loading="deleteLoading" color="#E72480" text @click="deleteFile(fileSelected)">تایید</v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
<!--                      </template>-->
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <v-file-input
                        style="font-family: anjoman!important;font-weight: normal!important;"
                        v-model="imgsFile"
                        label="تصویر های فرعی"
                        multiple
                        v-on:change="showImages($event)"
                        v-on:click:clear="deleteShowImages($event)"
                      >

                      </v-file-input>
                      <div
                        style="display: grid;grid-template-columns: repeat(auto-fill,75px);grid-column-gap: 10px"
                      >
                        <div v-for="(i) in editedItem.images">
                          <template>
                            <div v-if="updateImg(i.path)">
                              <v-img lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" width="75" alt="تصویر اطلاعیه" height="50px" style="margin: 0 10px" :src="baseUrl+i.path">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                              <v-icon
                                color="error"
                                small
                                @click="popImageFunc(i)"
                                color="red"
                              >
                                mdi-delete
                              </v-icon>
                            </div>
                          </template>

                        </div>
                        <v-img
                          width="75"
                          height="50"
                          style="margin: 0 10px"
                          v-for="img in imagesShow"
                          :src="img"
                        ></v-img>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"

                    >
                      <v-text-field
                        style="font-weight: normal"
                        v-model="editedItem.text"
                        label="متن"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <date-picker
                        v-model="editedItem.date"
                        style="font-family: anjoman!important;font-weight: normal!important;"
                        color='#E72480'
                        convert-numbers
                        label="تاریخ"
                        format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jDD"
                        placeholder="انتخاب تاریخ مورد نظر"

                      >
                      </date-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#E72480"
                  text
                  @click="close"
                >
                  لغو
                </v-btn>
                <v-btn
                  color="#E72480"
                  text
                  @click="save"
                  :loading="saveLoading"
                  :disabled="!editedItem.date"
                >
                  ذخیره
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog style="font-family: anjoman!important;" v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title style="font-family: anjoman!important;" class="headline">آيا از حذف این فروشگاه مطمئن می‌باشید؟</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn style="font-family: anjoman!important;" color="#E72480" text @click="closeDelete">لغو</v-btn>
                <v-btn style="font-family: anjoman!important;" color="#E72480" text @click="deleteItemConfirm">تایید</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn @click="editItem(item)" class="ml-2" icon text plain elevation="2">
        <v-icon
          medium
          color="blue"
        >
          mdi-pencil
        </v-icon>
        </v-btn>
        <v-btn   @click="deleteItem(item)" icon light text plain elevation="2">
        <v-icon
          medium
          color="red"
        >
          mdi-delete
        </v-icon>
        </v-btn>
      </template>

      <template v-slot:item.file="{item}">
        <v-img width="75" lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" v-if="item.file !== '0'" alt="تصویر اطلاعیه" height="50px" :src="item.file ? baseUrl+item.file :'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU'">
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </template>

      <template v-slot:item.images="{item}">
        <span  v-for="i in item.images">
          <v-img width="75" lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU" v-if="(i.path !== null)&& (i.path !== '0')"  alt="تصاویر اطلاعیه" height="50px" :src="baseUrl+i.path">
               <template v-slot:placeholder>
             <v-row
               class="fill-height ma-0"
               align="center"
               justify="center"
             >
               <v-progress-circular
                 indeterminate
                 color="grey lighten-5"
               ></v-progress-circular>
             </v-row>
           </template>
          </v-img>
        </span>
      </template>
      <template v-slot:item.date="{item}">
        <span>
          {{convert(item.date)}}
        </span>
      </template>

      <template v-slot:no-data>
        <v-btn
          color="#E72480"
          @click="refresh"
          text
          large
        >
          تازه‌سازی
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import {getNews , putNews , postNews , deleteNews} from '../../../api/news'
  import {toBase64} from "../../../plugins/toBase64";
  import {mapActions} from "vuex";
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
  import * as moment from 'jalali-moment';

    export default {
      name: "news",
      components:{
        datePicker: VuePersianDatetimePicker
      },
      data:()=>({
        saveLoading:false,
        deleteLoading:false,
        dataImagesFile:[],
        res : null,
        baseUrl:'',
        flagDialogFile: false,
        popImage: false,
        imageSelected : null,
        fileSelected :"",
        rowCount: null,
        covertJalaliDate: Date ,
        url: process.env.VUE_APP_BASE_URL,
        page: 1,
        pageSize: 5,
        dialog: false,
        dialogDelete: false,
        headers: [
          { text: 'تصویر', value: 'file' ,sortable: false, },
          {
            text: 'عنوان',
            align: 'start',
            value: 'title',
            width: 150
          },
          { text: 'تاریخ', value: 'date' },
          { text: 'متن اطلاعیه', value: 'text' },

          {text: 'تصاویر دیگر' , value: 'images' , sortable: false},
          { text: 'حذف - ویرایش', value: 'actions', sortable: false ,width:'150px'},
        ],
        desserts: [],
        editedItem: {
          // id: 0,
          title: '',
          date: null,
          text: '',
          file:null,
          images: []

        },
        defaultItem: {
          id: 0,
          title: '',
          date: null,
          text: '',
          file:null,
          images: []
        },
        deletedImages: {
          id: 0,
          images: []
        },
        deletedFile: {
          id: 0,
          file: null
        },
        editedIndex: -1,
        imageFile:null,
        imgsFile:[],
        mainImage:'',
        imagesShow:[],

      }),
      computed: {
        formTitle() {
          return this.editedIndex === -1 ? 'اضافه کردن اخبار' : 'تصحیح اخبار'
        },
      },
      watch: {


        dialog (val) {
          val || this.close()
        },
        dialogDelete (val) {
          val || this.closeDelete()
        },
      },
      methods: {
        showMainImage(e){
          if(e) {
            this.mainImage = URL.createObjectURL(e)
          }
        },
        deleteMainImage()
        {
          this.mainImage = ''
        },
        showImages(e){
          if(e.length!==0) {
            this.dataImagesFile.push(...this.imgsFile)
            e.forEach((i) => {
              this.imagesShow.push(URL.createObjectURL(i))
            })
          }
        },
        deleteShowImages(e){
          this.imagesShow = []
          this.dataImagesFile = []
        },
        ...mapActions({
          snackBarAction: 'snackBar/snackBarAction',
          setLoading : 'setLoading'

        }),
        editItem (item) {
          if(item.date==='0001-01-01T00:00:00'){
            item.date = ''
          }
          this.editedIndex = this.desserts.indexOf(item)
          this.editedItem = Object.assign({}, item)
          this.mainImage = this.baseUrl+this.editedItem.file
          this.dialog = true
          this.imagesShow = []
          this.mainImage = ''
          this.imageFile=[]
          this.imgsFile=[]
        },
        convert(inp){

          try {
            let l;

            l = moment(inp).locale('fa').format('YYYY/M/D');
            return  l
          }
          catch (e) {
            // console.log('ای بابا دوباره خطا داد', e);
          }
        }
        ,

        deleteItem (item) {
          this.editedIndex = this.desserts.indexOf(item)
          this.editedItem = Object.assign({}, item)
          this.dialogDelete = true
        },

        async deleteItemConfirm () {
            deleteNews(this.editedItem.id).then( async () => {
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات حذف با موفقیت اعمال شد', showSnackbar:true});
              this.closeDelete()
              await this.refresh()
            })
          .catch((e) => {
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })


        },

        close () {
          this.dialog = false
          this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          })
          this.imagesShow=[]
          this.mainImage = ''
          this.imageFile=[]
          this.imgsFile=[]
          this.dataImagesFile = []
        },

        closeDelete () {
          this.dialogDelete = false
          this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          })
          this.imagesShow=[]
          this.mainImage = ''
          this.imageFile=[]
          this.imgsFile=[]
          this.dataImagesFile = []
        },

        async imagesToBase64() {
          // if(this.imgsFile.length !== 0) {
            try {
              let i ;

              let l = this.editedItem.images.length;

              let v= [] ;
              for (i=0 ; i<this.dataImagesFile.length ;i++){

                this.editedItem.images[i + l] = {path: this.dataImagesFile[i] ? await toBase64(this.dataImagesFile[i]) : null}
                v.push(this.editedItem.images[i + l])
              }
              this.editedItem.images = v;
            }
            catch (e) {
              // console.log('خطاااااااا', e);
            }
          // }
        },
        updateImg (val){
          if( (val !== '0') && (val !== null) ){
            return 1
          }
          else
            return 0;
        },

        async save () {
          this.saveLoading = true
          if (this.editedIndex > -1) {
            this.editedItem.file = this.imageFile ? await toBase64(this.imageFile) : null
            await this.imagesToBase64()
            // Object.assign(this.desserts[this.editedIndex], this.editedItem)
            try {
              this.editedItem.images = this.editedItem.images.map(i => ({
                id: i.id,
                path: i.path

              }))
              await putNews(this.editedItem)
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات ویرایش با موفقیت اعمال شد', showSnackbar:true})
            }
            catch {
              this.snackBarAction({color:"error" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            }
            this.close()
            await this.refresh()

          }


          else {
            // this.desserts.push(this.editedItem)
            this.editedItem.file = this.imageFile ? await toBase64(this.imageFile) : null;
            await this.imagesToBase64()

            try {

              await postNews(this.editedItem)
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات افزودن  با موفقیت اعمال شد', showSnackbar:true})
            }
            catch(e) {
              this.snackBarAction({color:"error" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            }
            this.close()
            await this.refresh()
          }
          this.saveLoading = false
        },
        async deleteImages(val){
          if (val !== null)
          {
            let deleteImagesData = {id:0,images:[{id:0,path:''}]};
            deleteImagesData.id = this.editedItem.id;
            deleteImagesData.images = [{
              id : val.id,
              path : "0"
            }]
            try {
              await putNews(deleteImagesData);
              this.editedItem.images = this.editedItem.images.filter(function( obj ) {return obj.id !== val.id;});
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات ویرایش با موفقیت اعمال شد', showSnackbar:true});
            }
            catch (e) {
              this.snackBarAction({color:"error" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            }
            this.popImage = false;
            await this.refresh()
          }


          // this.editedItem.images.pop(val)
        },
        closeDeleteImage(){
          this.imageSelected = null;
          this.popImage = false;
          this.flagDialogFile = false;
        },
        closeDeleteFile(){
          this.fileSelected = "";
          this.flagDialogFile = false;
        },
        async deleteFile(val){
          this.deleteLoading = true
          if (val !== null)
          {
            this.deletedFile.id = this.editedItem.id;
            this.deletedFile.file =  "0";
            try {
              await putNews(this.deletedFile);
              this.editedItem.file = null;
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات ویرایش با موفقیت اعمال شد', showSnackbar:true});
            }
            catch (e) {
              this.snackBarAction({color:"error" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            }
            this.closeDeleteFile()
            await this.refresh()
          }
          this.deleteLoading = false
        },
        async refresh (){
          this.setLoading(true)
          try{

            this.res = await getNews(this.page , this.pagesSize)
            this.desserts = this.res.results
            this.rowCount = this.res.rowCount
            // this.imgsFile = []
            // this.page.itemsPerPage = this.desserts.pageSize
          }
          catch {
            this.snackBarAction({color:"error" , textSnackBar:'متاسفانه گرفتن اطلاعات با مشکل مواجه شد', showSnackbar:true})
          }
          this.setLoading(false)
        },
        async updateTable ( changeTableEvent){
          this.page = changeTableEvent.page;
          this.pagesSize = changeTableEvent.itemsPerPage;
          await this.refresh()

        },
        async popImageFunc(i){
          this.imageSelected = i;
          let yes = confirm('از حدف این تصویر مطمئن هستید؟')
          if (yes) {
            await this.deleteImages(i)
          }

        },
        async popFile(val){
          this.fileSelected = val;
          this.flagDialogFile = true
        }

      },
      mounted() {
          // this.getNewsData()
        this.baseUrl = process.env.VUE_APP_BASE_URL
        this.refresh()
      }
    }
</script>

<style>

</style>
<style scoped>
  #cardNews{
    width: 86.5%;
    margin: 0 auto;
  }

</style>
